const API = process.env.REACT_APP_BACKEND_URL;

export const TOKEN_KEY = "tripleo_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);

export async function adminFetch(path, options = {}) {
  const isForm = options.body instanceof FormData;
  const res = await fetch(`${API}${path}`, {
    ...options,
    headers: {
      ...(isForm ? {} : { "Content-Type": "application/json" }),
      Authorization: `Bearer ${getToken()}`,
      ...(options.headers || {}),
    },
  });
  if (res.status === 401) {
    localStorage.removeItem(TOKEN_KEY);
  }
  return res;
}
